import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 1920px;
  height: auto;
  margin: 0 auto;
  background: #efefef;
`;


export const Content = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
width: 100%;
max-width: 1920px;
background: #9032c0;
padding: 30px 15px;
h2 {
  color: #fff;
  margin-bottom: 20px;
  text-align: center;
  
}
`;

export const GroupForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 95%;
  min-height: 300px;
 
  h2 {
    color: #fff;
    margin-bottom: 20px;
    text-align: center;
    margin-top: 50px;
  }

  form {
    width: 90%;
    height: auto;
    max-width: 450px;

  }

  div.location-selection {
    display: flex;  
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;  
    background: gold;
  }

  div.location-permission {
    display: flex;
    flex-direction: column;
    aling-items: center;
    justify-content: center;
    width: 100%;
    height: auto;
    background: transparent;
    div {
      display: flex;
      flex-direction: row;
      aling-items: center;
      justify-content: center;
      width: 100%;
      height: auto;
      
        button.permitir {
          display: flex;
          aling-items: center;
          justify-content: center;  
          width: max-content;
          background: #682588;
          color: #fff;
          padding: 15px;
          border-radius: 5px;
          margin-right: 40px
          ;
        }
           button.nao-permitir {
          display: flex;
          aling-items: center;
          justify-content: center;  
          width: max-content;
          background: #682588;
          color: #fff;
          padding: 15px;
          border-radius: 5px;
          margin-right: 40px
          ;
        }
    }
  }



  button.sbmt {
    display: flex;
    aling-items: center;
    justify-content: center;
    width: max-content;
    padding: 15px;
    color: #fff;
    background: #69248d;
    border-radius: 5px;  
  }
  `;
